import $ from 'jquery';
import { debounce } from 'lodash';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/i18n/datepicker-ru.js';
import 'jquery-ui/ui/widgets/datepicker';
import './jquery.datepicker.extension.range.min.js';

$.datepicker.setDefaults($.datepicker.regional.ru);

const dateSelect = (element) => {
  const datePicker = element.querySelector('[data-calendar="date-picker"]');
  const dateStart = element.querySelector('[data-calendar="start-day"]');
  const dateEnd = element.querySelector('[data-calendar="end-day"]');
  const dateTop = element.querySelector('.date-select__top');

  const serviceDateData = element.querySelector('[data-calendar="service-date-data"]');

  const state = {
    isVisible: false,
  };

  $(datePicker).datepicker({
    range: 'period',
    onSelect(dateText, inst, extensionRange) {
      // extensionRange - объект расширения

      dateStart.innerText = extensionRange.startDateText;

      if (extensionRange.endDateText !== extensionRange.startDateText) {
        dateEnd.innerText = ` - ${extensionRange.endDateText}`;
        serviceDateData.value = `${extensionRange.startDateText};${extensionRange.endDateText}`;
      }
      if (extensionRange.endDateText <= extensionRange.startDateText) {
        dateEnd.innerText = '';
        serviceDateData.value = extensionRange.startDateText;
      }

      serviceDateData.dispatchEvent(new Event('change'));
    },
  });

  const extensionRange = $(datePicker).datepicker('widget').data('datepickerExtensionRange');

  if (extensionRange.startDateText) {
    dateStart.innerText = extensionRange.startDateText;
  }
  if (extensionRange.endDateText) {
    dateEnd.innerText = '';
  }

  $(dateTop).on('click', (event) => {
    $(datePicker).slideToggle('fast');
    state.isVisible = !state.isVisible;
    event.stopPropagation();
  });

  const onDocumentClick = (event) => {
    const triggerElement = event.target;
    const isCalendar = triggerElement.closest('[data-calendar="date-picker"]');
    const isCalendarNav = (triggerElement.classList.contains('ui-datepicker-next')
      || triggerElement.classList.contains('ui-datepicker-prev')
      || triggerElement.classList.contains('ui-icon')
    );

    if (isCalendar || isCalendarNav) {
      return;
    }

    if (state.isVisible) {
      state.isVisible = false;
      $(datePicker).slideToggle('fast');
    }
  };

  document.addEventListener('click', onDocumentClick);
};

const mountDateSelect = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="calendar"]'));

  elements.forEach(dateSelect);
};

export default mountDateSelect;
export { dateSelect };
